import { NgModule } from '@angular/core'

import { CopyTextComponent } from './copy-text.component'

@NgModule({
  imports: [],
  declarations: [CopyTextComponent],
  exports: [CopyTextComponent],
})
export class CopyTextModule {}
